export const defaultTheme: Record<string, string> = {
  label: "#033F44",
  labelVar2: "#165F54",
  buttonVar1: "#165F54",
  subtitleVar1: "#5C7083",
  subtitleVar2: "#6B727F",
  subtitleVar3: "#374151",
  bodyVar1: "#4B5563",
  azul: "#2561EB",
  titleVar1: "#1A5053",
  titleVar2: "#003D34",
  borderGrey: "#CED4D7",
  navy1: "#00243E",
  neon1: "#D4E52F",
};

export const ThemeColours = defaultTheme;
